<template>
  <div class="pool-slot" :style="{height: height + 'px'}"
    :draggable="draggable"
    @dragstart="onDragStart($event)"
    @drop="onDrop($event)"
    @dragover="onDragOver($event)">
    <div>
      <div class="pool-slot-country" v-if="map !== 0">{{country}}</div>
      <div class="pool-slot-map" v-if="map !== 0">{{map}}</div>
    </div>
    <div>
      <div class="pool-slot-name">{{name.replace(/\(.\)/, '')}}</div>
      <div class="pool-slot-dojo">{{dojo}}</div>
    </div>
    <div class="pool-slot-buttons" v-if="map !== 0">
      <div class="pool-slot-button-back" v-if="backButtonEnabled" @click="backClicked" :style="{height: height - 4 + 'px', width: height - 4 + 'px' }"></div>
      <div class="pool-slot-button-win" v-if="winButtonEnabled" @click="winClicked" :style="{height: height - 4 + 'px', width: height - 4 + 'px' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FighterSlot',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    winClicked: function () {
      this.$emit('winClicked')
    },
    backClicked: function () {
      this.$emit('backClicked')
    },
    onDragStart: function (event) {
      this.$emit('dragstart', event)
    },
    onDragOver: function (event) {
      this.$emit('dragover', event)
    },
    onDrop: function (event) {
      this.$emit('drop', event)
    }
  },
  props: {
    fighter: {
      type: Object,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    map: {
      required: false
    },
    country: {
      type: String,
      required: false
    },
    dojo: {
      required: false
    },
    height: {
      type: Number,
      required: true
    },
    winButtonEnabled: {
      type: Boolean,
      required: false
    },
    backButtonEnabled: {
      type: Boolean,
      required: false
    },
    draggable: {
      type: Boolean,
      required: false
    }
  }
}
</script>
